
//import {signalRConnection, signalRConnectionStart} from "fulogics-ui-core/build/signalR/signalRConnection";

const SIGNALR_DRIVER_ACCEPT_ORDER = "SIGNALR_DRIVER_ACCEPT_ORDER"
type signalRDriverAcceptOrderPayload =
    {

    }

export const signalRRegisterCommands = (store: any, callback: Function) => {
    /*signalRConnection.on(SIGNALR_DRIVER_ACCEPT_ORDER, async (item: signalRDriverAcceptOrderPayload) => {
        log.debug("SignalR command {cmd}, payload : {@payload}", SIGNALR_DRIVER_ACCEPT_ORDER, item);
        //

    });*/

    // jak powstanie endpoint do signalR trzeba to odkomentować :
    //signalRConnectionStart().then(callback());
    callback() // <- a to usunąć
};
